/**
 * Minimap constants
 */

// LocalStorage keys for minimap size (legacy global + per-campaign map)
export const MINIMAP_SIZE_KEY = 'minimap-size';
export const MINIMAP_SIZE_BY_CAMPAIGN_KEY = 'minimap-size-by-campaign';

// Default size constraints
export const DEFAULT_MAX_WIDTH = 250;
export const DEFAULT_MAX_HEIGHT = 180;
export const MIN_SIZE = 80;
export const MAX_SIZE = 400;

/** Shorter edge of the rendered minimap cannot be dragged below this (px) */
export const MIN_MINIMAP_EDGE_PX = 20;

